<div class="p-3">
  <button (click)="toggleMenu()"
          class="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-white/5 hover:text-slate-900 dark:hover:text-slate-200 transition-all duration-200 cursor-pointer group">
    <app-avatar [employeeId]="employeeId" [profile]="profile" class="flex-shrink-0"></app-avatar>
    @if (appMain.sidebarActive || appMain.sidebarStatic) {
      <div class="flex-1 min-w-0 text-left">
        <p class="text-sm font-medium text-slate-700 dark:text-slate-200 truncate m-0">{{ fullName }}</p>
        <p class="text-xs text-slate-400 dark:text-slate-500 truncate m-0">{{ email }}</p>
      </div>
      <i class="pi pi-angle-up text-xs text-slate-400 transition-transform duration-200 flex-shrink-0"
         [class.rotate-180]="!inlineMenuActive"></i>
    }
  </button>

  @if (inlineMenuActive && (appMain.sidebarActive || appMain.sidebarStatic)) {
    <ul class="mt-1 flex flex-col gap-0.5 list-none p-0">
      <li>
        <a routerLink="/account/profile"
           class="flex items-center gap-3 px-3 py-2 rounded-xl text-sm text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-white/5 transition-colors no-underline">
          <i class="pi pi-user text-xs text-slate-400"></i>
          <span>Perfil</span>
        </a>
      </li>
      <li>
        <a routerLink="/account/configuration"
           class="flex items-center gap-3 px-3 py-2 rounded-xl text-sm text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-white/5 transition-colors no-underline">
          <i class="pi pi-cog text-xs text-slate-400"></i>
          <span>Configuración</span>
        </a>
      </li>
      <li class="border-t border-slate-100 dark:border-slate-800 mt-1 pt-1">
        <a (click)="logout()"
           class="flex items-center gap-3 px-3 py-2 rounded-xl text-sm text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors cursor-pointer no-underline">
          <i class="pi pi-sign-out text-xs"></i>
          <span>Salir</span>
        </a>
      </li>
    </ul>
  }
</div>